module.exports = __webpack_public_path__ + "static/bg_4-66c91653fcf382d9370046aff8df3f80.jpg";